<template>
  <InputCitySuggest
    :ref="this.$root.nameField"
    :required="true"
    :typeField="'select'"
    :filtered="this.$root.filtered"
    :placeholder="placeholder"
    @change-city="onChangeCity"
    @change-country-code="onChangeCountryCode"
  />
</template>
<script>
import InputCitySuggest from './InputCitySuggest.vue';

export default {
  name: 'FormbarCitySuggest',
  components: { InputCitySuggest },
  created() {
    if (this.$root.nameField.indexOf('From') !== -1) {
      this.placeholder = 'Город-отправитель';
    } else {
      this.placeholder = 'Город-получатель';
    }
  },
  mounted() {
    document.addEventListener('checkCalcCityFrom', (value) => {
      if (this.$refs.formbarFrom) {
        this.$refs.formbarFrom.cityCodeData = value.detail;
      }
    });
    document.addEventListener('checkCalcCityTo', (value) => {
      if (this.$refs.formbarTo) {
        this.$refs.formbarTo.cityCodeData = value.detail;
      }
    });
  },
  data() {
    return {
      placeholder: null,
    };
  },
  methods: {
    onChangeCity(value) {
      if (value) {
        if (this.$root.nameField.indexOf('From') !== -1) {
          document.dispatchEvent(new CustomEvent('checkFixBarCityFrom', { detail: { value, flag: true } }));
        } else {
          document.dispatchEvent(new CustomEvent('checkFixBarCityTo', { detail: { value, flag: true } }));
        }
      }
    },
    onChangeCountryCode(countryCode) {
      if (countryCode) {
        if (this.$root.nameField.indexOf('From') !== -1) {
          document.dispatchEvent(new CustomEvent('checkFixBarCountryFrom', { detail: { countryCode, flag: true } }));
        } else {
          document.dispatchEvent(new CustomEvent('checkFixBarCountryTo', { detail: { countryCode, flag: true } }));
        }
      }
    },
  },
};
</script>
